import { useScriptInjector } from '../useScriptInjector';
import {useEffect} from 'react';
import {useWebViewStore} from "../../webview/useWebViewStore";
import { useLocation  } from 'react-router-dom';
import './qualitrcs.css';
import { AMPLITUDE_EVENTS } from '../../../constants';
import { useAnalytics } from '../amplitude';

const Qualtrics = () => {

  const isScriptDefer = true;
  const isAsync = false;
  const { webviews } = useWebViewStore();
  const active = webviews.find((iframe:any) => iframe.active);
  const location = useLocation();
  const { trackEvent } = useAnalytics();
  
  const script = useScriptInjector(
    `/thirdParty/qualtrics.feedback.min.js`,
    isAsync,
    isScriptDefer,
    "qualtrics");

 useEffect(() => {
      const id = active?.id;
      const feedbackButton = document.querySelector(".QSIFeedbackButton") as HTMLElement
      if(location.pathname.indexOf('-admin') !== -1 || id){
        if(feedbackButton){
          feedbackButton.style.display = 'none'
        }   
      }else{
        if(feedbackButton){
          feedbackButton.style.display = 'flex'
        } 
      }
  }, [script,active,location]);


  useEffect(() => {
      const handleFeedbackClick = (evt: MouseEvent) => {
        try {
          const feedbackButton = (evt.target as HTMLElement).parentElement;
          if (
            feedbackButton?.id === 'QSIFeedbackButton-btn' &&
            feedbackButton.getAttribute('aria-expanded') === 'true'
          ) {
            trackEvent(AMPLITUDE_EVENTS.OPEN_FEEDBACK);
          }
        } catch (err) {
          console.warn('Amplitude - Feedback Tracking error', err);
        }
      };
      document.addEventListener('click', handleFeedbackClick); 
      return () => {
        document.removeEventListener('click', handleFeedbackClick);
      };
    }, [trackEvent]);
  

  return <></>;
}

export default Qualtrics; 